"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarningMessageComponent = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var getSeverityClassName = function (warningMessage) {
    if (typeof warningMessage === "string") {
        return "gd-mvf-warning-message-low s-mvf-warning-message-low";
    }
    switch (warningMessage.severity) {
        case "low":
            return "gd-mvf-warning-message-low s-mvf-warning-message-low";
        case "medium":
            return "gd-mvf-warning-message-medium s-mvf-warning-message-medium";
        case "high":
            return "gd-mvf-warning-message-high s-mvf-warning-message-high";
    }
};
exports.WarningMessageComponent = function (_a) {
    var warningMessage = _a.warningMessage, className = _a.className;
    var messageClassName = classnames_1.default("gd-mvf-warning-message", getSeverityClassName(warningMessage), className, "s-mvf-warning-message");
    return (react_1.default.createElement("div", { className: messageClassName }, warningMessage.text || warningMessage));
};
//# sourceMappingURL=WarningMessage.js.map